module.exports = __webpack_public_path__ + "assets/webgl/LM.5.jpg.0c20ebb6.webp";